<template>
  <div class="App">
    <router-view></router-view>

    <!-- 侧边栏弹出蒙版 -->
    <transition name="fade">
      <div class="mask1" v-if="state_sidebar_show" @click="StoreSetSidebarShow(false)"></div>
    </transition>

    <!-- 用户信息弹出蒙版 -->
    <transition name="fade">
      <div class="mask2" v-if="state_userinfo_show" @click="StoreSetUserinfoShow(false)"></div>
    </transition>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions } from "vuex";
export default {
  name: "App",
  data() {
    return {};
  },
  created() {
    /* 判断本地是否存在token */
    if (this.state_token) {
      this.StoreGetUserInfo();
    }
    this.StoreSetScreenWidth(window.innerWidth);
    window.addEventListener("resize", () => {
      this.StoreSetScreenWidth(window.innerWidth);
      this.$bus.$emit("resize"); //全局监听窗口
    });
  },
  computed: {
    ...mapState("user", {
      state_token: "token",
    }),
    ...mapState("global", {
      state_sidebar_show: "sidebar_show",
      state_userinfo_show: "userinfo_show",
    }),
  },
  methods: {
    ...mapActions("user", {
      StoreGetUserInfo: "getUserInfo",
    }),
    ...mapMutations("global", {
      StoreSetScreenWidth: "setScreenWidth", //设置设备宽度
      StoreSetSidebarShow: "setSidebarShow", //设置显示/隐藏侧边栏
      StoreSetUserinfoShow: "setUserinfoShow", //设置显示/隐藏用户信息
    }),
  },
};
</script>
<style scoped lang="less">
.App {
  position: relative;
  width: 100vw;
  min-width: 360px;
  height: 100vh;
  .mask1,
  .mask2 {
    position: fixed;
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.75);
    z-index: 2;
  }
  .mask1 {
    z-index: 3;
  }
}
</style>
